import './Hero.scss';

import { Col, Row } from 'react-bootstrap';
import { faClock, faLock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { CasrcadeLockup } from '@components/marketing/CasrcadeLockup/CasrcadeLockup';

import { PromiseCard } from './PromiseCard';

export const Hero = () => (
  <section className='hcp-hero'>
    <div className='container-xxl'>
      <CasrcadeLockup />

      <Row className='hcp-hero__row gx-4 gy-4'>
        <Col xs={12} md={7} className='hcp-hero__primary'>
          <div className='hcp-hero__eyebrow'>For referring clinicians</div>
          <h1 className='hcp-hero__heading'>Refer a patient for genetic test report review</h1>
          <p className='hcp-hero__lead'>
            One form to start an internal review of your patient&apos;s report. We take it from here.
          </p>
          <div className='hcp-hero__pills'>
            <span className='hcp-hero__pill'>
              <FontAwesomeIcon icon={faClock} className='hcp-hero__pill-icon' aria-hidden='true' />
              About 3 minutes
            </span>
            <span className='hcp-hero__pill'>
              <FontAwesomeIcon icon={faLock} className='hcp-hero__pill-icon' aria-hidden='true' />
              No login required
            </span>
          </div>
        </Col>
        <Col xs={12} md={5} className='hcp-hero__aside'>
          <PromiseCard />
        </Col>
      </Row>
    </div>
  </section>
);
